import { withInstall } from '@vuemap/vue-amap-util'
import Marker from './Marker.vue'

export const ElAmapMarker = withInstall(Marker)
export default ElAmapMarker
